export enum EntityType {
  Participant,
  Employer
}
